import dynaForms from '@elab/core/utils/dynaForms';

export const getTypes = storeName => ({
    ...dynaForms.getTypes(storeName),
    CANCEL: `${storeName}.DATE_CANCEL`,
    RESET: `${storeName}.DATE_RESET`,
});
